import * as types from '../types';

/**
 * 模块管理器store模块
 */
const modules = {
  state: {
    currentModule: ''
  },
  getters: {
    activeModule: state => state.currentModule // 当前底部选中模块
  },
  mutations: {

  }
};

export default modules;
